import { render, staticRenderFns } from "./keyword-drawer.vue?vue&type=template&id=035d2336&"
import script from "./keyword-drawer.vue?vue&type=script&lang=js&"
export * from "./keyword-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports